import PaginationPresenter from "../../../pagination/presenter/pagination.js";

export default class Pagination extends PaginationPresenter {
  constructor(element) {
    super(element);
  }

  _init() {
    super._init();
  }
}
